import React, { PureComponent } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { Container, InnerContainer } from './styles';

import YoutubePublish from './Youtube/component';
import TwitterPublish from './Twitter/component';
import LanSettings from './LAN/component';
import YahooSettings from './Yahoo/component';

import PublishProfilesList from './ProfilesList/component';
import { IProps } from './interfaces';
import { IState } from '../../state/search';
import { Routes as AppRoutes } from '../../constants';

class PublishProfiles extends PureComponent<IProps, IState> {
  render() {
    return (
      <Container>
        <InnerContainer>
          <Routes>
            <Route index element={<PublishProfilesList />} />
            <Route path="new/youtube" element={<YoutubePublish />} />
            <Route path="edit/youtube" element={<YoutubePublish />} />
            <Route path="new/twitter" element={<TwitterPublish />} />
            <Route path="edit/twitter" element={<TwitterPublish />} />
            <Route path="new/lan" element={<LanSettings />} />
            <Route path="edit/lan" element={<LanSettings />} />
            <Route path="new/yahoo" element={<YahooSettings />} />
            <Route path="edit/yahoo" element={<YahooSettings />} />
            <Route path="*" element={<Navigate to={AppRoutes.PUBLISH_PROFILES} replace />} />
          </Routes>
        </InnerContainer>
      </Container>
    );
  }
}

export default PublishProfiles;
